module.exports = {"baseUrl":"https://benjandsara.com","title":"Benjamin Drummond + Sara Joy Steele","tagline":"We craft stories about the natural world in the human age.","email":{"label":"mail@benjandsara.com","value":"mail@benjandsara.com"},"twitterHandle":"benjdrummond","social":[{"title":"Instagram","icon":"instagram","link":"https://www.instagram.com/benjdrummond"},{"title":"Vimeo","icon":"vimeo","link":"https://vimeo.com/benjandsara"}],"facebookAppId":"168056707314636"}


//////////////////
// WEBPACK FOOTER
// ./src/data/site.yaml
// module id = 507
// module chunks = 1474